import { render, staticRenderFns } from "./TravelInvoiceOptions.vue?vue&type=template&id=156c3552&scoped=true"
import script from "./TravelInvoiceOptions.vue?vue&type=script&lang=js"
export * from "./TravelInvoiceOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156c3552",
  null
  
)

export default component.exports